<template>
  <div class="flex-none block lg:hidden">
    <div class="drawer">
      <input id="my-drawer" type="checkbox" class="drawer-toggle" />
      <div class="drawer-content">
        <!-- Page content here -->
        <label for="my-drawer" class="btn btn-square btn-ghost drawer-button">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            class="inline-block h-5 w-5 stroke-current"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h16"
            ></path>
          </svg>
        </label>
      </div>
      <div class="drawer-side py-2">
        <label for="my-drawer" aria-label="close sidebar" class="drawer-overlay"></label>

        <div
          class="bg-base-100 space-y-4 rounded-2xl shadow-md h-full border w-56 border-base-content/10"
        >
          <div class="text-center font-bold text-xl pt-4">KOPERASI</div>

          <NavMenu />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import NavMenu from './NavMenu.vue'
export default {
  name: 'NavMobile',
  components: {
    NavMenu,
  },
}
</script>

<style></style>
